import { render } from "./PurchaseOrderTable.vue?vue&type=template&id=efce8196"
import script from "./PurchaseOrderTable.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderTable.vue?vue&type=script&lang=js"

import "./PurchaseOrderTable.vue?vue&type=style&index=0&id=efce8196&lang=postcss"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__